import styled from 'styled-components';

export const ParagraphSizeText = styled.div`
  &&& {
    font-size: 16px;
    line-height: 1.3;
  }
`;
